module.exports = __webpack_public_path__ + "img/Z71_10.6a47eff4.jpg";